import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { MenuController, ModalController } from '@ionic/angular';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppSettings } from 'src/app/enums/app-settings.enum';
import { AdobeAnalyticsService } from 'src/app/services/adobe-analytics.service';
import { GoogleAnalyticsService } from 'src/app/services/google-analytics.service';
import { SubjectService } from 'src/app/services/subject.service';

@Component({
  selector: 'app-sort',
  templateUrl: './sort.component.html',
  styleUrls: ['./sort.component.scss']
})
export class SortComponent implements OnInit {
  @Input('sorts') sorts: any;
  @Input('sorted') sorted: any;
  public filters: any;
  unsubscribe$: Subject<boolean> = new Subject();
  selectedSort: any;
  constructor(
    private cdr: ChangeDetectorRef,
    private GAS: GoogleAnalyticsService,
    private AAS: AdobeAnalyticsService,
    private SS: SubjectService,
    private modalController: ModalController
  ) {}
  ngOnInit() {
  }
  ngAfterViewInit(){
  }
  ngOnDestroy() {
    this.unsubscribe$.next(true);
    this.unsubscribe$.complete();
  }
  async ionViewDidEnter() {}

  openEnd() { }

  closeMenu() { }

  sortSelection(s: any) {
    
    this.selectedSort = s;
    this.cdr.detectChanges();
  }
  applySort() {
    this.SS.selectedSort.next(this.selectedSort);
    this.dismiss();
  }
  async resetSort() {
    this.dismiss();
  }
  dismiss() {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    this.modalController.dismiss({
      dismissed: true,
    });
  }
}
